import './HandlebarsHelpers'
import Moment from 'moment'

const filterNullElement = "alle"
const filterSplitChar = "|"
var filmTemplate = require('../../views/' + baseTheme + '/film/' + filmTpl + '-hbs.hbs')
var filterTemplate = require('../../views/' + baseTheme + '/film/filter-hbs.hbs')

class FilmFilter{

    /**
     * @constructor
     * @param {Array} films the original list of films
     */
    constructor(films, filmTpl,scheduleSite){
        /**
         * @private
         * @type {Array<string>}
         */
        this._activeFilterWhen = []
        /**
         * @private
         * @type {Array<string>}
         */
        this._activeFilterWhat = []
        /**
         * @private
         * @type {Array<string>}
         */
        /**
         * @private
         * @type {Array<string>}
         */
        this._activeFilterFsk = []
        /**
         * @private
         * @type {Array<string>}
         */
        this._activeFilterLine = []
        /**
         * @private
         * @type {Array<string>}
         */
        this._activeFilterCinema = []
        /**
         * @private
         * @type {Array<string>}
         */
        this._activeFilterAuditorium = []


        this._films = films
        this._filmTpl = filmTpl
        /**
         * @private
         * @type {Function}
         */
        this.scheduleView = 'standard'


        this._filterApplied = this._filterApplied.bind(this)
        this.registerFilterChangeEvent = this.registerFilterChangeEvent.bind(this)
        this.registerScheduleViewEvent = this.registerScheduleViewEvent.bind(this)
        this._applyFilters = this._applyFilters.bind(this)
        this._lineFilter = this._lineFilter.bind(this)
        this._cinemaFilter = this._cinemaFilter.bind(this)
        this._whatFilter = this._whatFilter.bind(this)
        this._whenFilter = this._whenFilter.bind(this)
        this._fskFilter = this._fskFilter.bind(this)
        this._auditoriumFilter = this._auditoriumFilter.bind(this)
        this._filterObject = this._filterObject.bind(this)
        this._toggleFilter = this._toggleFilter.bind(this)
        this._whenPerformanceFilter = this._whenPerformanceFilter.bind(this)
        this._auditoriumPerformanceFilter = this._auditoriumPerformanceFilter.bind(this)
        this._appendFilterParamToUrl = this._appendFilterParamToUrl.bind(this)
        this._initialSetFiltersFromUrl = this._initialSetFiltersFromUrl.bind(this)
        this._isFilterActive = this._isFilterActive.bind(this)
        this._initialOrderPerformances = this._initialOrderPerformances.bind(this)

        this._initialOrderPerformances()
        this._initialSetFiltersFromUrl()
    }

    _initialOrderPerformances(){
        for(let filmKey in this._films){
            let film = this._films[filmKey]

            let performances = []
            let performancesCompact = []
            let currentDay = ''


            film.performances.forEach(performanceWrapper =>{
                for(let key in performanceWrapper.performances){

                let performance = performanceWrapper.performances[key]

                // multiple Sites

                let attributeKey = ''
                let attributeKeyCompact = ''
                let performanceKey = ''
                let attributeSort = ''

                if(performanceWrapper.attributeName != null){
                    attributeKey = performanceWrapper.attributeName.join('-')
                }
                if (performanceWrapper.attributeSort != null) {
                    attributeSort = performanceWrapper.attributeSort
                    attributeSort = attributeSort.toString()
                         while (attributeSort.length < 8) {
                            attributeSort = "0" + attributeSort
                          }
                }
                if(performanceWrapper.attributeSlug != null){
                    attributeKeyCompact = performanceWrapper.attributeSlug
                }

                let keyStr =  performance.date + attributeKey
                if(currentDay != keyStr){
                    currentDay = keyStr
                }

                if(this._filmTpl == 'film-compact') {
                    performanceKey = attributeKeyCompact
                    if (attributeKeyCompact == "") {
                        performanceKey = "zzzzzzzzzz"
                    }
                } else {
                    performanceKey = currentDay
                }

                if (scheduleSite) {
                    performance.siteName = performanceWrapper.siteName
                    performance.siteId = performanceWrapper.siteId
                    performanceKey = performanceWrapper.siteName+"|"+performanceKey
                }
                if(performances[performanceKey] == null){
                    performances[performanceKey] = []
                    performances[performanceKey]['attributeName'] = performanceWrapper.attributeName
                    performances[performanceKey]['attributeSort'] = performanceWrapper.attributeSort
                    performances[performanceKey]['attributeSlug'] = performanceWrapper.attributeSlug
                    performances[performanceKey]['attributeNameSlug'] = performanceWrapper.attributeNameSlug
                    performances[performanceKey]['siteName'] = performanceWrapper.siteName
                    performances[performanceKey]['siteId'] = performanceWrapper.siteId
                }
                let position = performances[performanceKey].length
                if(position == 0){
                    performances[performanceKey][position] = performance
                }else{
                    while(position > 0 && performance.unixdatetime < performances[performanceKey][position - 1].unixdatetime){
                        position--;
                    }
                    performances[performanceKey].splice(position, 0, performance)
                }
            }
        })

            // convert performances from object to array, else attributeName and -slug will disappear
            // days
            let key2 = ""
            for(let key in performances){
                let obj = {}
                for(let perfKey in performances[key]){
                    obj[perfKey] = performances[key][perfKey]
                }
                if (typeof performances[key][0] != "undefined") {
                    key2 = performances[key][0]['unixdatetime']+'_'+key
                    performances[key2] = obj
                }
                delete performances[key]
            }

            let keys = Object.keys(performances)
            keys.sort()

            let c = 0
            let savesite = ""
            if (scheduleSite) {
                for(let key of keys){
                    let keysplit =  key.split('|');
                    let site = keysplit[0]
                    performances[c] = performances[key]
                    if (key.search("zzzzzzzzzz") > 0 && c > 0 &&  savesite == site)  {
                        performances[c]['attributeNameSlug'] = [" "]
                    }
                    if (savesite != site)  {
                        performances[c]['showCinema'] = performances[c]['siteName']
                    }
                    savesite = site
                    delete performances[key]
                    c++
                }
            }
            else {
                for(let key of keys){
                    performances[c] = performances[key]
                    if (key.search("zzzzzzzzzz") > -1 && c > 0)  {
                        performances[c]['attributeNameSlug'] = [" "]
                    }

                    delete performances[key]
                    c++
                }
            }

            film.performances = performances
            // console.log( film.performances);
        }

    }

    _isFilterActive(){
        return this._activeFilterLine.length != 0
            || this._activeFilterWhat.length != 0
            || this._activeFilterWhen.length != 0
            || this._activeFilterCinema.length != 0
            || this._activeFilterAuditorium.length != 0
            || this._activeFilterFsk.length != 0
    }



    /**
     * Registers the Filter-change-events
     * @returns {void}
     */
    registerFilterChangeEvent(){
        let that = this
        $('.filterLine').on('change', evt => {
            that._toggleFilter(evt, that._activeFilterLine)
    })
        $('.filterCinema').on('change', evt => {
            that._toggleFilter(evt, that._activeFilterCinema)
    })
        $('.filterAuditorium').on('change', evt => {
            that._toggleFilter(evt, that._activeFilterAuditorium)
    })
        $('.filterWhat').on('change', evt => {
            that._toggleFilter(evt, that._activeFilterWhat)
    })
        $('.filterFsk').on('change', evt => {
            that._toggleFilter(evt, that._activeFilterFsk)
    })
        $('.filterWhen').on('change', evt => {
            let isAllChecked = $('.filterWhenAll').prop('checked')
            if(isAllChecked === true){
            $('.filterWhenAll').prop('checked', false)
        }
        that._toggleFilter(evt, that._activeFilterWhen)
    })
        $('.filterWhenAll').on('change', evt => {
            let control = evt.target
            if(control.checked === true){
            that._activeFilterWhen = []
            $('.filterWhen').prop('checked', false)
            that._applyFilters()
        }
    })
    }

    registerScheduleViewEvent(){
        let that = this

        $('.pills-tab').click(function() {
            $('.pills-tab').removeClass('active')
            $(this).addClass('active')
            scheduleView = $(this).attr('data-toggle')
            that._applyFilters()

        });


    }

    _toggleFilter(evt, filter){

        let control = evt.target
        let filterId = control.id
        if(control.checked === true)
        {
            filter.push(filterId)
        }else{
            let index = filter.indexOf(filterId)
            if(index > -1)
            {
                filter.splice(index, 1)
            }
        }

        this._applyFilters()
    }

    /**
     * Applies the active Filters on the given Film-Array
     * @param {Array} films
     */
    _applyFilters(){
        $(".filter-notification").removeClass("filter-notification-animation")
        window.setTimeout(() => $(".filter-notification").addClass("filter-notification-animation"), 50)

        let copy = JSON.parse(JSON.stringify(this._films))

        let filteredFilms = this._filterObject(copy, this._whenFilter)

        filteredFilms = this._filterObject(filteredFilms, this._whatFilter)

        filteredFilms = this._filterObject(filteredFilms, this._lineFilter)

        filteredFilms = this._filterObject(filteredFilms, this._cinemaFilter)

        filteredFilms = this._filterObject(filteredFilms, this._auditoriumFilter)

        filteredFilms = this._filterObject(filteredFilms, this._fskFilter)

        if(this._filmTpl == 'film-compact') {
        //    console.log(filteredFilms);
            filteredFilms = this._filterObject(filteredFilms, x => {

                 let hasPerformance = false
                    for(let i=0; i< x.performances.length; i++){
                        hasPerformance = false
                 /*       if (scheduleView == 'table') {
                            let today       =new Date();
                            let in_a_week   =new Date().setDate(today.getDate()+7);
                            let in_three_week   =new Date().setDate(today.getDate()+21);
                            let in_week   =new Date().setDate(today.getDate()+(x.lastPerformanceWeek * 7));
                            console.log(in_week);
                            console.log(x.lastPerformanceWeek);
                            if ((x.firstPerformance * 1000 )> in_week) {
                                return false
                            }
                        }   */
                        for(let key in x.performances[i]){
                            if(x.performances[i][key] instanceof Object){
                                if(!isNaN(parseInt(key))){
                                    hasPerformance = true;
                                }
                            }
                        }
                        if(hasPerformance) {

                            return hasPerformance
                        }
                    }
                return false
            })
        } else {
            filteredFilms = this._filterObject(filteredFilms, x => {
                    for(let i=0; i< x.performances.length; i++){
                if(x.performances[i][0] != null){
                    return true
                }
            }
            return false
        })
        }

        if (scheduleSite) {

            for(let filmKey in filteredFilms){
                let film = filteredFilms[filmKey]
                let siteName = ""
                film.performances.forEach(performance =>{
                    if (siteName != performance.siteName && performance[0]) {
                    performance.showCinema = performance.siteName
                    performance.showSiteID = performance.siteId
                    siteName  =    performance.siteName
                }
            else {
                    performance.showCinema = false
                }
            })
            }
        }

        this._appendFilterParamToUrl()
        this._filterApplied(filteredFilms)
        moveInterscroller()
    }

    _lineFilter(film){
        if(this._activeFilterLine.length == 0){
            return true
        }

        film.performances = film.performances.filter(performance => {
                if(performance.attributeSlug == null || performance.attributeSlug.length == 0){
            return false
        }
        let attributeSlugs = performance.attributeSlug
        for(let attributeSlugKey in attributeSlugs){
            let attributeSlug = attributeSlugs[attributeSlugKey]
            let preResult = this._activeFilterLine.indexOf(attributeSlug) > -1
            if(preResult){
                return true
            }
        }
        return false
    })
        return film.performances.length > 0
    }

    _cinemaFilter(film){
        if(this._activeFilterCinema.length == 0){
            return true
        }
        for(let cinemaKey in film.filmSite){
            let currentCinema = film.filmSite[cinemaKey]

            let preResult = this._activeFilterCinema.indexOf(cinemaKey) > -1

            if(preResult){
                for(let i=0; i<film.performances.length; i++){
                    let performance = film.performances[i]
                    performance =  this._filterObject(performance, (x, key) => {
                            if(this._activeFilterCinema.indexOf( performance.siteId.toString()) > -1){
                        return true
                    }
                    return false
                })
                    film.performances[i] = performance
                }
                return true
            }
        }

        return false
    }

    _auditoriumFilter(film){
        if(this._activeFilterAuditorium.length == 0){
            return true
        }
        let hasItems = false
        let perf = film.performances

        for(let i=0; i<film.performances.length; i++){
            film.performances[i] =   this._filterObject(film.performances[i],  this._auditoriumPerformanceFilter)
            if(!hasItems && film.performances[i] != null){
                hasItems = film.performances[i].length > 0
            }
        }

        return hasItems
    }

    _whatFilter(film){
        if(this._activeFilterWhat.length == 0){
            return true
        }

        for(let releaseKey in film.filmReleasesCombinedFixed){
            let currentRelease = film.filmReleasesCombinedFixed[releaseKey]
            let preResult = this._activeFilterWhat.indexOf(currentRelease) > -1
            if(preResult){
                for(let i=0; i<film.performances.length; i++){
                    let performance = film.performances[i]
                    performance =  this._filterObject(performance, (x, key) => {
                            let keyAsInt = parseInt(key)
                            if(isNaN(keyAsInt)){
                        return true
                    }
                    if(x == null){
                        return false
                    }
                    for(let j = 0; j< x.releasesCombined.length; j++){
                        if(this._activeFilterWhat.indexOf(x.releasesCombined[j]) > -1){
                            return true
                        }
                    }
                    return false
                })
                    film.performances[i] = performance
                }
                return true
            }
        }
        return false
    }

    _fskFilter(film){
        if(this._activeFilterFsk.length == 0){
            return true
        }

        return this._activeFilterFsk.includes(film.fsk)
    }

    _whenFilter(film){

        if(this._activeFilterWhen.length == 0){
            return true
        }

        let hasItems = false
        let perf = film.performances

        if(this._filmTpl == 'film-compact') {
            for(let i=0; i<film.performances.length; i++){
                film.performances[i] =   this._filterObject(film.performances[i], this._whenPerformanceFilter)
                if(!hasItems && film.performances[i] != null){
                    hasItems = film.performances[i].length > 0
                }
            }
        } else {
            for(let i=0; i<film.performances.length; i++){
                film.performances[i] = this._filterObject(film.performances[i], this._whenPerformanceFilter)
                if(!hasItems && film.performances[i] != null){
                    hasItems = film.performances[i].length > 0
                }
            }
        }

        return hasItems
    }

    _whenPerformanceFilter(performance, key){
        if(isNaN(parseInt(key))){
            return true
        }
        let curDate = Moment(performance.date, "yyyy-MM-DD")
        let allowAll = this._activeFilterWhen.indexOf('all') > -1
        if(allowAll){
            return true
        }
        for(let key in this._activeFilterWhen){
            let rawFilterDate = this._activeFilterWhen[key]
            let useIsAfter = false
            if(rawFilterDate.startsWith('starting_')){
                rawFilterDate = rawFilterDate.substr(9)
                useIsAfter = true
            }

            let filterDate = Moment(rawFilterDate, "DD.MM")
            let preResult = filterDate.isSame(curDate, 'day') || (useIsAfter && curDate.isAfter(filterDate, 'day'))
            // only return when the result is true, if there are more days than one selected
            // and false is returned it may lead to a false result
            if(preResult){
                return true
            }
        }
        return false
    }

    _auditoriumPerformanceFilter(performance, key){
        if(isNaN(parseInt(key))){
            return true
        }
      //  console.log(performance.performanceAuditoriumAttributeTitle)

        if (performance.performanceAuditoriumAttributeTitle == null) {
            return false
        }

        let auditoriumAttributes = this._activeFilterAuditorium

        for(let i=0; i<auditoriumAttributes.length; i++){
            for(let j=0; j<performance.performanceAuditoriumAttributeTitle.length; j++) {
                if(performance.performanceAuditoriumAttributeTitle[j].slug == auditoriumAttributes[i]) {
                    return true
                }
            }
        }

        return false
    }

    _filterObject(obj, predicate){
        let tmp = []
        let result = []
        let counter = 0
        for(let key in obj){
            if(obj.hasOwnProperty(key) && predicate(obj[key], key)){
                if (!isNaN(parseInt(key)) && obj[key]['filmTitle'] == undefined) {
                    tmp[counter] = obj[key];
                    counter++;
                }   else {
                    tmp[key] = obj[key];
                }
            }
        }

        for(let key in tmp){
            result[key] = tmp[key]
        }
        return result
    }

    /**
     *
     * @param {string} filterName
     * @param {Array<string>} filter
     */
    _appendFilterParamToUrl(){
        let filterStrings = []
        let isAnyFilterActivated = false

        if(this._activeFilterLine.length > 0){
            isAnyFilterActivated = true
            filterStrings.push(this._activeFilterLine.join(filterSplitChar))
        }else{
            filterStrings.push(filterNullElement)
        }
        if(this._activeFilterWhen.length > 0){
            isAnyFilterActivated = true
            filterStrings.push(this._activeFilterWhen.join(filterSplitChar))
        }else{
            filterStrings.push(filterNullElement)
        }
        if(this._activeFilterWhat.length > 0){
            isAnyFilterActivated = true
            filterStrings.push(this._activeFilterWhat.join(filterSplitChar))
        }else{
            filterStrings.push(filterNullElement)
        }
        if(this._activeFilterCinema.length > 0){
            isAnyFilterActivated = true
            filterStrings.push(this._activeFilterCinema.join(filterSplitChar))
        }else{
            filterStrings.push(filterNullElement)
        }
        if(this._activeFilterAuditorium.length > 0){
            isAnyFilterActivated = true
            filterStrings.push(this._activeFilterAuditorium.join(filterSplitChar))
        }else{
            filterStrings.push(filterNullElement)
        }
        if(this._activeFilterFsk.length > 0){
            isAnyFilterActivated = true
            filterStrings.push(this._activeFilterFsk.join(filterSplitChar))
        }else{
            filterStrings.push(filterNullElement)
        }
        let url = ""

        if(!isAnyFilterActivated){
            url = document.location.origin + "/programm"
        }else{
            url = document.location.origin + "/programm/filter/" + filterStrings.join('/')
        }

        window.history.pushState({}, "", url)
    }

    _initialSetFiltersFromUrl(){
        let performanceFilter = window.urlFilter['performanceSeries']
        if(performanceFilter != null && performanceFilter != filterNullElement){
            this._activeFilterLine = performanceFilter.split(filterSplitChar)
            for(let i=0;i< this._activeFilterLine.length; i++){
                $('#' + this._activeFilterLine[i]).prop('checked', true)
            }
        }

        let whenFilter = window.urlFilter['when']
        if(whenFilter != null && whenFilter != filterNullElement){
            this._activeFilterWhen = whenFilter.split(filterSplitChar)
            for(let i=0; i< this._activeFilterWhen.length; i++){
                $('#' + this._activeFilterWhen[i]).prop('checked', true)
            }
        }

        let whatFilter = window.urlFilter['what']
        if(whatFilter != null && whatFilter != filterNullElement){
            this._activeFilterWhat = whatFilter.split(filterSplitChar)
            for(let i = 0; i< this._activeFilterWhat.length; i++){
                $('#' + this._activeFilterWhat[i]).prop('checked', true)
            }
        }
        let cinemaFilter = window.urlFilter['cinema']

        if(cinemaFilter != null && cinemaFilter != filterNullElement){
            this._activeFilterCinema = cinemaFilter.split(filterSplitChar)
            for(let i=0;i< this._activeFilterCinema.length; i++){
                $('#' + this._activeFilterCinema[i]).prop('checked', true)
            }
        }
        let auditoriumFilter = window.urlFilter['auditorium']

        if(auditoriumFilter != null && auditoriumFilter != filterNullElement){
            this._activeFilterAuditorium = auditoriumFilter.split(filterSplitChar)
            for(let i=0;i< this._activeFilterAuditorium.length; i++){
                $('#' + this._activeFilterAuditorium[i]).prop('checked', true)
            }
        }

        let fskFilter = window.urlFilter['fsk']

        if(fskFilter != null && fskFilter != filterNullElement){
            this._activeFilterFsk = fskFilter.split(filterSplitChar)
            for(let i=0;i< this._activeFilterFsk.length; i++){
                $('#' + this._activeFilterFsk[i]).prop('checked', true)
            }
        }
        this._applyFilters()
    }

    _filterApplied(films){
        let filmCounter = 0
        let visibleEventsAmount = 0
        const maxShownEvents = 3
        const moviesBetweenEvents = 3
        $('#filmContainer').empty()
        for(let key in films){

            if(!films.hasOwnProperty(key)){
                continue
            }
            let film = films[key]
            filmCounter++
            if(filmCounter != 0 && filmCounter % moviesBetweenEvents == 0 && !this._isFilterActive() && window.events.length > visibleEventsAmount){
                film.event = window.events[visibleEventsAmount]
                visibleEventsAmount++
            }
            $(filmTemplate(films[key]))
                .appendTo('#filmContainer')
        }
        window.initScheduleTables();
    }
}


/**
 *
 * @param {String} attributName
 * @returns {String[]}
 */
function getBadgeAttributes(attributName)
{
    if(attributName == null)
    {
        return null;
    }
    return attributName.split(',')
}

/**
 *
 * @param {string} date
 * @returns {{title: string, text: string}}
 */
function getPerformanceDateText(date)
{
    return dateTimes[date]
}
$(function(){
    for(let key in window.films)
    {
        if(!films.hasOwnProperty(key))
        {
            continue;
        }
        let film = films[key]
        film.performances.attributeName = getBadgeAttributes(film.performances.attributeName)
        for(let pkey in film.performances){
            let performance = film.performances[pkey]
            if(performance == null || performance.attributeName == null){
                continue
            }
            performance.attributeName = performance.attributeName.split(',')
            performance.attributeSlug = performance.attributeSlug.split(',')
            // console.log(performance.attributeNameSlug);

        }
        for(pkey in film.performances.performances)
        {
            film.performances.performances[pkey].date = getPerformanceDateText(film.performances.performances[pkey].date)
        }
        film.performanceDays = film.combinedLastPerformanceWeek * 7;

    }

    $(filterTemplate(window))
        .appendTo('#filterContainer')
    var filmFilter = new FilmFilter(films, filmTpl,scheduleSite)

    filmFilter.registerFilterChangeEvent()
    filmFilter.registerScheduleViewEvent()

})

